module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c5be71297df282279435e6659cad70fa.png";